import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SaveProfilePicUseCase extends BaseUseCase {
    constructor(saveProfilePicRep) {
        super();
        this.saveProfilePicRep = saveProfilePicRep;
    }
    async fetchResult(req) {
        return await this.saveProfilePicRep.saveProfilePicData(req);
    }
}
export default SaveProfilePicUseCase;
